import React from 'react';
import { Button, Wrapper } from './styles/LoadMoreGenericBtn.styled';

export default function LoadMoreGenericBtn({ color, position, label, onClick, dir, className }) {
  return (
    <Wrapper position={position} dir={dir}>
      <Button color={color} onClick={onClick} className={className} dir={dir}>
        {label}
      </Button>
    </Wrapper>
  );
}
